module.exports = __webpack_public_path__ + "static/blog73-552d3a5b55ec2a4b542bd2303aba5d12.png";